export const EVENT_SEARCH = 'event_search';
export const EVENT_CHANGE_DATA = 'event_change_Data';
export const EVENT_CHANGE_ADDRESS = 'event_change_address';
export const EVENT_CHANGE_PERSONS = 'event_change_persons';
